module.exports = __webpack_public_path__ + "static/media/aboutBackground.46bf92fc.png";